import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { auth } from '/Users/michaeltucker/Documents/coding-projects/client/src/firebase.js';
import { saveReferralCode, normalizeReferralCode } from 'utils/referralStorage';

export default function ReferralRedirect() {
  const history = useHistory();
  const { referralCode } = useParams();

  useEffect(() => {
    const normalized = normalizeReferralCode(referralCode);
    if (normalized && !auth.currentUser) {
      saveReferralCode(normalized);
    }

    history.replace('/auth/register');
  }, [history, referralCode]);

  return (
    <div
      style={{
        minHeight: '40vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#4b5563',
      }}
    >
      Redirecting to signup...
    </div>
  );
}
